<template>
  <SelectComponent
    class="filter-select"
    :value="valueComp"
    :empty-label="$t('select') + '...'"
    v-bind="$attrs.options"
    @input="$ev => $emit('input', $ev)"
  />
</template>

<script>
import SelectComponent from '@kvass/custom-fields/src/Fields/SelectModal'

export default {
  props: ['value'],
  computed: {
    valueComp() {
      if (this.$attrs.options.multiple && !(this.value instanceof Array)) return [this.value].filter(Boolean)
      return this.value
    },
  },
  components: {
    SelectComponent,
  },
}
</script>

<style lang="scss">
.filter-select {
  .elder-input__field {
    border-color: rgba(0, 0, 0, 0.1);
    background-color: transparent;
  }

  .elder-input__element {
    padding: 0.75em;
  }

  .elder-input__value {
    .field-select-modal__item {
      &-thumbnail {
        width: 2.5rem;
      }
    }
  }
}
</style>
